import React from 'react'
import '../assets/css/banner.css';

function AnimatedBackground(props) {
  let height;

  if(props.name === 'Sociopreneurs'){
    height = '400vh'
  }
  else if(props.name === 'Tamasha'){
    height = '490vh'
  }
  else if(props.name === 'Bazinga'){
    height = '390vh'
  }
  else if(props.name === '404 Resolved'){
    height = '450vh'
  }
  else if(props.name === 'All Rise'){
    height = '350vh'
  }
  else if(props.name === 'Ingenious Geeks'){
    height = '470vh'
  }


  return (
    <div classname='animated'>
       <div class="area" style={{height : height}}>
                <ul class="circles">
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>

                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                        <li style={{background : props.color}}></li>
                </ul>
        </div > 
    </div>
  )
}

export default AnimatedBackground